import loadable from '@loadable/component';
import * as React from 'react';

/** Путь не сокращать! сломаешь lazy loading */
import { Loading } from '../../../components/OffersHistory/Mobile/commonComponents/Loading';

/* istanbul ignore next */
export const OffersHistoryContentLoadable = loadable(() => import('./OffersHistoryContentContainer'), {
  fallback: <Loading />,
});
